import { render, staticRenderFns } from "./MoreAboutUs.vue?vue&type=template&id=ee7dba66&scoped=true&"
import script from "./MoreAboutUs.vue?vue&type=script&lang=js&"
export * from "./MoreAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./MoreAboutUs.vue?vue&type=style&index=0&id=ee7dba66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7dba66",
  null
  
)

export default component.exports